import{useEffect as e}from"react";const n=(n,t)=>{e((()=>{const e=e=>{t&&!t.includes(e.key)||n(e)};return document.addEventListener("keydown",e),()=>{document.removeEventListener("keydown",e)}}),[n,t])};export{n as useKeydown};
